/* Wolpic · Editor de álbumes (estilo Artifact Uprising) · Ecom Project
   Plantilla product.personalizador en los álbumes:
   1. Landing: tamaño, páginas, color de tapa, precio y botón "Empieza a diseñar".
   2. Editor paso a paso a pantalla completa: portada → páginas 1 y 2 → … → revisión → carrito.
      Diseños (cuadrículas) por página, fotos de Uploadly que se arrastran o tocan, encuadre (zoom y posición),
      límite de fotos según la capacidad comprada y revisión final antes de agregar.
   El diseño se guarda en la línea del pedido: una propiedad por página ("Pág 01" = diseño + fotos) y _diseno_album.
   Mientras la pestaña siga abierta, el diseño se conserva al cambiar de tamaño (sessionStorage). */
(function () {
  'use strict';

  var root = document.querySelector('[data-wp-al]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var D = JSON.parse(root.querySelector('[data-wp-al-data]').textContent);
  var P = D.product;
  var DEMO = /[?&]demo=1/.test(location.search);
  var TOUCH = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);

  /* ---------- diseños de página: espacios en % de la página [x, y, ancho, alto] ---------- */
  function grid(cols, rows, m, g) {
    var out = [], w = (100 - 2 * m - (cols - 1) * g) / cols, hh = (100 - 2 * m - (rows - 1) * g) / rows;
    for (var r = 0; r < rows; r++) for (var c = 0; c < cols; c++) out.push([m + c * (w + g), m + r * (hh + g), w, hh]);
    return out;
  }
  var LAYOUTS = [
    { id: 'full', name: 'Foto completa', slots: [[0, 0, 100, 100]] },
    { id: 'one', name: '1 foto con borde', slots: [[10, 10, 80, 80]] },
    { id: 'text', name: 'Foto y texto', slots: [[10, 8, 80, 64]], text: [10, 76, 80, 16] },
    { id: 'two-v', name: '2 lado a lado', slots: [[6, 18, 42, 64], [52, 18, 42, 64]] },
    { id: 'two-h', name: '2 una sobre otra', slots: [[12, 6, 76, 42], [12, 52, 76, 42]] },
    { id: 'three', name: '1 grande + 2', slots: [[6, 6, 56, 88], [65, 6, 29, 42.5], [65, 51.5, 29, 42.5]] },
    { id: 'three-row', name: '3 en fila', slots: [[6, 30, 27.33, 40], [36.33, 30, 27.33, 40], [66.67, 30, 27.33, 40]] },
    { id: 'four', name: '4 en cuadrícula', slots: grid(2, 2, 6, 4) },
    { id: 'five', name: '2 arriba + 3 abajo', slots: [[6, 6, 42, 42], [52, 6, 42, 42], [6, 52, 27.33, 42], [36.33, 52, 27.33, 42], [66.67, 52, 27.33, 42]] },
    { id: 'six', name: '6 en cuadrícula', slots: grid(3, 2, 6, 3) }
  ];
  var LMAP = {}; LAYOUTS.forEach(function (l) { LMAP[l.id] = l; });
  function layoutForCount(n) { return n <= 1 ? 'one' : n === 2 ? 'two-v' : n === 3 ? 'three' : n === 4 ? 'four' : n === 5 ? 'five' : 'six'; }

  /* ---------- utilidades ---------- */
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function h(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function money(cents) {
    var f = String(D.money_format || 'S/ {{amount}}').replace(/<[^>]*>/g, ''), n = Number(cents) / 100;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) { return k === 'amount_no_decimals' ? Math.round(n).toString() : n.toFixed(2); });
  }
  function img(u, w) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function productForm() { return $('form.product-form[action*="/cart/add"]') || $('form[action*="/cart/add"]:not(#sticky-product-form)'); }
  function currentVariant() {
    var f = productForm(), input = f && f.querySelector('[name="id"]'), id = input ? String(input.value) : '';
    for (var i = 0; i < P.variants.length; i++) if (String(P.variants[i].id) === id) return P.variants[i];
    return P.variants[0];
  }
  function optName(i) { var o = P.options[i]; return String((o && o.name) || o || ''); }
  function findOpt(re) { for (var i = 0; i < P.options.length; i++) if (re.test(optName(i).toLowerCase())) return i; return -1; }
  var IDX = { cap: findOpt(/capacidad|p[aá]gina/), color: findOpt(/color/) };
  /* otras opciones con más de un valor (p. ej. "Estilo", "Diseño Portada"): se eligen en la portada del editor */
  function extraOpts() { var out = []; P.options.forEach(function (o, i) { if (i !== IDX.cap && i !== IDX.color && values(i).length > 1) out.push(i); }); return out; }
  function values(i) { var seen = {}, out = []; P.variants.forEach(function (v) { var x = v.options[i]; if (!seen[x]) { seen[x] = 1; out.push(x); } }); return out; }
  function variantFor(opts) {
    for (var i = 0; i < P.variants.length; i++) { var v = P.variants[i], ok = true; for (var k = 0; k < opts.length; k++) if (v.options[k] !== opts[k]) { ok = false; break; } if (ok) return v; }
    return null;
  }
  /* cambiar una opción de forma segura: se calcula la variante destino, se sincroniza el selector del tema
     y, si el tema no actualizó el formulario, se fuerza el id de la variante (el carrito siempre usa ese id) */
  function selectOption(i, value) {
    var opts = currentVariant().options.slice(); opts[i] = value;
    var target = variantFor(opts);
    if (target && target.available === false) target = null;
    if (!target) {
      for (var k = 0; k < P.variants.length; k++) if (P.variants[k].options[i] === value && P.variants[k].available !== false) { target = P.variants[k]; break; }
      if (!target) { toast('Esa opción está agotada por ahora'); renderLanding(); if (editorOpen) renderSide(); return; }
      if (IDX.cap > -1 && i !== IDX.cap && target.options[IDX.cap] !== currentVariant().options[IDX.cap]) toast('Ese color solo está disponible en ' + capLabel(target.options[IDX.cap]).big + ' (' + money(target.price) + ')');
    }
    target.options.forEach(function (val, idx) {
      if (currentVariant().options[idx] === val) return;
      var group = $('.product-option-group[data-option-index="' + idx + '"]');
      if (group) $$('[data-value]', group).forEach(function (b) { if (b.getAttribute('data-value') === val) b.click(); });
    });
    setTimeout(function () { forceVariant(target); afterVariant(); }, 150);
  }
  function forceVariant(v) {
    var f = productForm(), inp = f && f.querySelector('[name="id"]');
    if (inp && String(inp.value) !== String(v.id)) { inp.value = v.id; inp.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  var lastVariantId = null, lastMax = 0;
  function afterVariant() {
    var v = currentVariant();
    if (String(v.id) === lastVariantId) { renderLanding(); if (editorOpen) renderEditor(); return; }
    lastVariantId = String(v.id);
    var before = S.pages.length, beforeMax = lastMax; syncPages(); lastMax = capacity(v).max;
    if (S.files.length && before && S.pages.length !== before) {
      if (!S.touched) { autofill(); toast('Repartimos tus fotos en ' + S.pages.length + ' páginas'); }
      else toast(S.pages.length > before ? 'Agregamos ' + (S.pages.length - before) + ' páginas al final: llénalas o usa "Repartir fotos"' : 'Ahora son ' + S.pages.length + ' páginas: revisa las últimas');
    }
    else if (S.files.length && !S.touched && beforeMax && beforeMax !== lastMax) { autofill(); toast('Repartimos tus fotos para ' + lastMax + ' fotos'); }
    else if (S.files.length && placedTotal() > capacity(v).max) toast('Este álbum incluye hasta ' + capacity(v).max + ' fotos: revisa las páginas antes de finalizar');
    renderLanding(); if (editorOpen) renderEditor(); else writeProperties();
  }
  function toast(msg) {
    var t = h('div', 'wpae-toast', esc(msg)); document.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-on'); }, 20);
    setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300); }, 3000);
  }
  /* "10 pág. (20 fotos)" → { big: "10 páginas", small: "20 fotos" } */
  function capLabel(val) {
    var s = String(val), pg = s.match(/(\d+)\s*p[aá]g/i), ph = s.match(/\(([^)]*)\)/);
    if (pg) return { big: pg[1] + ' páginas', small: ph ? ph[1] : '' };
    return { big: s, small: '' };
  }
  function family() {
    for (var i = 0; i < D.family.length; i++) if (D.family[i].handle === D.current) return D.family[i];
    /* álbum que no es de la familia principal (promos, diseños especiales): su medida sale de las opciones o del título */
    var txt = [P.title].concat(P.options.map(function (o, k) { return values(k).join(' '); })).join(' '), m = txt.match(/(\d{2})\s*x\s*(\d{2})/i);
    var a = m ? +m[1] : 20, b = m ? +m[2] : 20, key = [a, b].sort().join('x'), hit = null;
    D.family.forEach(function (f) { var s = String(f.size).match(/(\d{2})\s*x\s*(\d{2})/); if (s && [+s[1], +s[2]].sort().join('x') === key) hit = f; });
    var min = P.variants.reduce(function (x, v) { return Math.min(x, v.price); }, Infinity);
    return { handle: D.current, self: true, name: hit ? hit.name : '', size: hit ? hit.size : a + 'x' + b + ' cm', w: hit ? hit.w : a, h: hit ? hit.h : b, photos: '', from: money(min), url: location.pathname };
  }
  var FAM = family(), AR = FAM.w / FAM.h;

  /* capacidad: "10 pág. (20 fotos)", "12 pág. (40 a 50 fotos)", "150 a 200 fotos" */
  function capacity(v) {
    var s = IDX.cap > -1 ? String(v.options[IDX.cap]) : String(FAM.photos);
    var pages = s.match(/(\d+)\s*p[aá]g/i), r = s.match(/(\d+)\s*a\s*(\d+)\s*fotos/i), one = s.match(/(\d+)\s*fotos/i);
    var max = r ? +r[2] : one ? +one[1] : 40, min = r ? +r[1] : null;
    return { pages: pages ? +pages[1] : Math.max(10, Math.ceil(max / 4)), min: min, max: max };
  }

  /* ---------- estado ---------- */
  var S = { prints: {}, files: [], carried: {}, pages: [], cover: { photo: null, title: '', subtitle: '', crop: null }, spread: 0, sel: { page: -1, slot: null }, tab: 'portada', drag: null, review: false, touched: false };
  function capOf(p) { return p && LMAP[p.layout] && LMAP[p.layout].text ? (p.caption || '') : ''; }
  function newPage(lid) { var L = LMAP[lid || 'two-v']; return { layout: L.id, slots: L.slots.map(function () { return null; }), crops: [], caption: '' }; }
  function syncPages() {
    var n = capacity(currentVariant()).pages;
    while (S.pages.length < n) S.pages.push(newPage('two-v'));
    if (S.pages.length > n) S.pages.length = n;
    if (S.spread > spreadsCount() - 1) S.spread = spreadsCount() - 1;
    if (S.sel.page >= n) S.sel = { page: -1, slot: null };
  }

  /* ---------- fotos (Uploadly) ---------- */
  /* Uploadcare: se conserva el recorte o la edición que el cliente hizo en Uploadly (-/crop/…, -/rotate/…) */
  function ucParts(u) {
    var m = String(u || '').match(/^(https?:\/\/[^/]*(?:ucarecdn|ucarecd\.net)[^/]*\/[0-9a-f-]{36}\/)(.*)$/i);
    if (!m) return null;
    var mods = (m[2] || '').replace(/-\/(preview|resize|scale_crop|quality|format|progressive|stretch)\/[^/]*\/?/g, '').replace(/^\/+/, '');
    if (mods && mods.slice(-1) !== '/') mods += '/';
    return { base: m[1], mods: mods };
  }
  function photoUrl(f, size) {
    var p = ucParts(f.url);
    if (p) return p.base + p.mods + '-/preview/' + size + 'x' + size + '/-/quality/smart/';
    return f.url || '';
  }
  function editedUrl(f) { var p = ucParts(f.url); return p && p.mods ? p.base + p.mods : ''; }
  function setFiles(list) {
    var oldIds = S.files.map(function (f) { return f.uuid; });
    S.files = list.filter(function (f) { return f && f.url; });
    var map = {}; S.files.forEach(function (f, k) { map[f.uuid] = k; });
    function remap(k) { return k == null ? null : (map[oldIds[k]] != null ? map[oldIds[k]] : null); }
    S.pages.forEach(function (p) { p.slots = p.slots.map(remap); });
    S.cover.photo = remap(S.cover.photo);
    if (S.cover.photo == null && S.files.length) { S.cover.photo = 0; S.cover.crop = null; }
  }
  function filesFromDom() {
    var out = [];
    $$('[data-img-id]').forEach(function (el) {
      var id = el.getAttribute('data-img-id');
      if (!id || out.some(function (f) { return f.uuid === id; })) return;
      var inp = el.querySelector('input[name^="properties["]');
      out.push({ uuid: id, name: '', url: (inp && inp.getAttribute('data-cdn')) || 'https://ucarecdn.com/' + id + '/', link: (inp && inp.value) || '' });
    });
    return out;
  }
  function openUploader() {
    var field = window.UPLOADCARE_FIELD, d = window.UPLOADCARE_DATA && window.UPLOADCARE_DATA[field];
    try { if (d) { if (d.activate) d.activate(); if (d.widget && d.widget.openDialog) { d.widget.openDialog(); return; } } } catch (e) {}
    var btn = $('[id*="uploadly_file_upload"] button, [id*="uploadly_file_upload"] [role="button"]');
    if (btn) btn.click();
  }
  /* lista completa: fotos traídas de otro tamaño de álbum (si las hay) + las que Uploadly tiene en esta página */
  function mergeFiles(evt) {
    var dom = filesFromDom(), list = dom.length >= evt.length ? dom.map(function (f) {
      var x = null; evt.forEach(function (e) { if (e.uuid === f.uuid) x = e; });
      return x ? { uuid: f.uuid, name: x.name, url: x.url || f.url, link: x.link || f.link } : f;
    }) : evt;
    var have = {}; list.forEach(function (f) { have[f.uuid] = 1; });
    var carried = S.files.filter(function (f) { return S.carried[f.uuid] && !have[f.uuid]; });
    return list.concat(carried);
  }
  document.addEventListener('uploadly:upload-complete', function (e) {
    var d = e.detail || {};
    if (DEMO) { S.files = []; S.pages = []; S.cover = { photo: null, title: '', subtitle: '', crop: null }; S.touched = false; syncPages(); DEMO = false; $('.wpae-demo-slot', ed).innerHTML = ''; }
    var before = S.files.length; cleared = false;
    setFiles(mergeFiles((d.files || []).map(function (f) { return { uuid: f.uuid, name: f.name, url: f.cdnUrl || f.uploadlyUrl, link: f.uploadlyUrl || f.cdnUrl || '' }; })));
    if (!before && S.files.length) autofill();
    else if (S.files.length > before) {
      var free = 0; S.pages.forEach(function (p) { p.slots.forEach(function (k) { if (k == null) free++; }); });
      toast((S.files.length - before) + ' fotos nuevas en "Fotos"' + (free ? ': arrástralas a los espacios vacíos' : ''));
    }
    renderLanding(); if (editorOpen) renderEditor();
  });
  function usedCount() {
    var c = {};
    S.pages.forEach(function (p) { p.slots.forEach(function (k) { if (k != null) c[k] = (c[k] || 0) + 1; }); });
    return c;
  }
  function placedTotal() { var n = 0; S.pages.forEach(function (p) { p.slots.forEach(function (k) { if (k != null) n++; }); }); return n; }
  function emptySlots() { var out = []; S.pages.forEach(function (p, i) { p.slots.forEach(function (k) { if (k == null) out.push(i); }); }); return out; }

  /* autocompletar: reparte las fotos en orden (hasta la capacidad comprada) y elige el diseño según cuántas tocan */
  function autofill() {
    var cap = capacity(currentVariant()), n = Math.min(S.files.length, cap.max), pages = S.pages.length; if (!n) return;
    var k = 0;
    for (var i = 0; i < pages; i++) {
      var remainingPages = pages - i, remaining = n - k;
      var take = remaining <= 0 ? 0 : Math.max(1, Math.min(6, Math.round(remaining / remainingPages)));
      if (remaining > 0 && remaining < take) take = remaining;
      var lid = take ? (i === 0 && take === 1 ? 'full' : layoutForCount(take)) : 'one';
      var L = LMAP[lid], slots = [];
      for (var s = 0; s < L.slots.length; s++) slots.push(s < take && k < n ? k++ : null);
      S.pages[i] = { layout: lid, slots: slots, crops: [], caption: '' };
    }
    S.sel = { page: S.sel.page, slot: null }; pick = null; S.touched = false;
  }
  function setLayout(pi, lid, quiet) {
    if (!quiet) S.touched = true;
    var p = S.pages[pi], L = LMAP[lid], photos = [], crops = [], slots = [], keep = [];
    p.slots.forEach(function (k, si) { if (k != null) { photos.push(k); crops.push(p.crops[si] || null); } });
    for (var s = 0; s < L.slots.length; s++) { slots.push(s < photos.length ? photos[s] : null); keep.push(s < photos.length ? crops[s] : null); }
    p.layout = lid; p.slots = slots; p.crops = keep;
    if (S.sel.page === pi && S.sel.slot != null && S.sel.slot >= L.slots.length) S.sel.slot = null;
    var out = photos.length - L.slots.length;
    if (out > 0 && !quiet) toast(out + (out > 1 ? ' fotos quedaron fuera de esta página: están en "Fotos" sin usar' : ' foto quedó fuera de esta página: está en "Fotos" sin usar'));
    return out;
  }
  /* mismo diseño en todas las páginas: las fotos se vuelven a repartir en orden para no perder ninguna */
  function layoutAll(lid) {
    var order = []; S.pages.forEach(function (p) { p.slots.forEach(function (k) { if (k != null) order.push(k); }); });
    var L = LMAP[lid], i = 0;
    S.pages.forEach(function (p) { p.layout = lid; p.crops = []; p.slots = L.slots.map(function () { return i < order.length ? order[i++] : null; }); });
    if (i < order.length) toast((order.length - i) + ' fotos no entran con este diseño: están en "Fotos" sin usar');
  }

  /* ---------- encuadre de cada foto (zoom y posición) ---------- */
  /* ajustes de cada foto (recorte, zoom, giro, espejo, filtros): editor compartido wp-photo-edit.js */
  function PE() { return window.WPEdit || null; }
  function getCrop(pi, si) { var c = pi === -1 ? S.cover.crop : S.pages[pi].crops[si]; return PE() ? PE().norm(c || {}) : (c || { x: 50, y: 50, z: 1 }); }
  function setCrop(pi, si, c) {
    if (c) c = PE() ? PE().norm(c) : { x: Math.round(c.x * 10) / 10, y: Math.round(c.y * 10) / 10, z: Math.round(c.z * 100) / 100 };
    S.touched = true;
    if (pi === -1) S.cover.crop = c; else S.pages[pi].crops[si] = c;
  }
  function cropIsSet(c) { if (PE()) return !!c && PE().isSet(c); return c && (c.z > 1.01 || Math.abs(c.x - 50) > 1 || Math.abs(c.y - 50) > 1); }
  function imgTag(file, size, c) {
    if (PE()) return PE().imgHtml(photoUrl(file, size), c || {}, 'wpae-img', size <= 200);
    c = c || { x: 50, y: 50, z: 1 };
    return '<img class="wpae-img" src="' + esc(photoUrl(file, size)) + '" alt="" draggable="false"' + (size <= 200 ? ' loading="lazy"' : '') + ' style="object-position:' + c.x + '% ' + c.y + '%;transform:scale(' + c.z + ');transform-origin:' + c.x + '% ' + c.y + '%">';
  }
  function applyCrop(el, c) {
    var im = el && el.querySelector('.wpae-img'); if (!im) return;
    if (PE()) { PE().apply(im, c || {}); return; }
    im.style.objectPosition = c.x + '% ' + c.y + '%'; im.style.transformOrigin = c.x + '% ' + c.y + '%'; im.style.transform = 'scale(' + c.z + ')';
  }

  /* ---------- colocar fotos (con el límite de fotos del álbum) ---------- */
  function getSlot(pi, si) { return pi === -1 ? S.cover.photo : S.pages[pi].slots[si]; }
  function placeFile(k, pi, si) {
    if (pi === -1) { if (S.cover.photo !== k) S.cover.crop = null; S.cover.photo = k; return true; }
    var p = S.pages[pi];
    if (!p || si == null || si >= LMAP[p.layout].slots.length) return false;
    var cur = p.slots[si];
    S.touched = true;
    if (k != null && cur == null) {
      var cap = capacity(currentVariant());
      if (placedTotal() >= cap.max) { toast('Tu álbum incluye hasta ' + cap.max + ' fotos. Quita una foto o elige más páginas.'); return false; }
    }
    if (cur !== k) p.crops[si] = null;
    p.slots[si] = k;
    return true;
  }
  function swapSlots(a, b) {
    var ka = getSlot(a.page, a.slot), kb = getSlot(b.page, b.slot), ca = a.page === -1 ? S.cover.crop : S.pages[a.page].crops[a.slot], cb = b.page === -1 ? S.cover.crop : S.pages[b.page].crops[b.slot];
    if (a.page === -1) { S.cover.photo = kb; S.cover.crop = cb; } else { S.pages[a.page].slots[a.slot] = kb; S.pages[a.page].crops[a.slot] = cb; }
    if (b.page === -1) { S.cover.photo = ka; S.cover.crop = ca; } else { S.pages[b.page].slots[b.slot] = ka; S.pages[b.page].crops[b.slot] = ca; }
  }

  /* ---------- guardar el diseño mientras la pestaña siga abierta (también al cambiar de tamaño) ---------- */
  var KEY = 'wpae:diseno', saveT, cleared = false;
  function uuidOf(k) { return k != null && S.files[k] ? S.files[k].uuid : null; }
  function save(now) {
    clearTimeout(saveT);
    if (now) return doSave();
    saveT = setTimeout(doSave, 250);
  }
  function doSave() {
    (function () {
      if (DEMO || cleared || !S.files.length) return;
      try {
        sessionStorage.setItem(KEY, JSON.stringify({
          t: Date.now(),
          files: S.files.map(function (f) { return { uuid: f.uuid, name: f.name || '', url: f.url, link: f.link || '' }; }),
          cover: { photo: uuidOf(S.cover.photo), title: S.cover.title, subtitle: S.cover.subtitle, crop: S.cover.crop },
          pages: S.pages.map(function (p) { return { l: p.layout, s: p.slots.map(uuidOf), c: p.crops, t: p.caption || '' }; })
        }));
      } catch (e) {}
    })();
  }
  function load() {
    try { var o = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (o && o.files && Date.now() - o.t < 8 * 3600e3) return o; } catch (e) {}
    return null;
  }
  function restoreDesign(o) {
    var idx = {}; S.files.forEach(function (f, k) { idx[f.uuid] = k; });
    function k(u) { return u != null && idx[u] != null ? idx[u] : null; }
    S.cover.title = o.cover.title || ''; S.cover.subtitle = o.cover.subtitle || '';
    if (k(o.cover.photo) != null) { S.cover.photo = k(o.cover.photo); S.cover.crop = o.cover.crop || null; }
    if (!o.pages || !o.pages.length) return false;
    var n = capacity(currentVariant()).pages;
    S.pages = o.pages.slice(0, n).map(function (p) {
      var L = LMAP[p.l] || LMAP.one;
      return { layout: L.id, slots: L.slots.map(function (r, si) { return k((p.s || [])[si]); }), crops: (p.c || []).slice(0, L.slots.length), caption: p.t || '' };
    });
    while (S.pages.length < n) S.pages.push(newPage('two-v'));
    S.touched = true;
    return true;
  }

  /* ---------- propiedades del pedido ---------- */
  function cropText(c) {
    if (!cropIsSet(c)) return '';
    if (PE()) return ' (ajustada: ' + PE().describe(c) + ')';
    var z = c.z > 1.01 ? 'zoom ×' + String(Math.round(c.z * 10) / 10).replace('.', ',') + ', ' : '';
    return ' (encuadre: ' + z + 'foco ' + Math.round(c.x) + ' % horizontal / ' + Math.round(c.y) + ' % vertical)';
  }
  function writeProperties() {
    var f = productForm(); if (!f) return;
    $$('[data-wpae-prop]', f).forEach(function (n) { n.remove(); });
    function add(name, val) { var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + name + ']'; i.value = val; i.setAttribute('data-wpae-prop', '1'); f.appendChild(i); }
    var v = currentVariant(), cover = [];
    if (IDX.color > -1) cover.push('Tapa ' + String(v.options[IDX.color]).toLowerCase());
    if (S.cover.title) cover.push('Título: "' + S.cover.title + '"');
    if (S.cover.subtitle) cover.push('Subtítulo: "' + S.cover.subtitle + '"');
    if (S.cover.photo != null && S.files[S.cover.photo]) cover.push('Foto ' + (S.cover.photo + 1) + cropText(S.cover.crop));
    add('Portada', cover.join(' · ') || 'Sin cambios');
    S.pages.forEach(function (p, i) {
      var cap = capOf(p);
      if (!p.slots.some(function (k) { return k != null; }) && !cap) return;
      var photos = p.slots.map(function (k, si) { return k == null ? '—' : 'Foto ' + (k + 1) + cropText(p.crops[si]); });
      add('Pág ' + pad2(i + 1), LMAP[p.layout].name + ': ' + photos.join(', ') + (cap ? ' · Texto: "' + cap + '"' : ''));
    });
    // fotos que vienen de otro tamaño de álbum: no están en Uploadly de esta página, se guarda su enlace
    S.files.forEach(function (fl, k) {
      if (S.carried[fl.uuid]) add('Foto ' + pad2(k + 1), fl.link || fl.url);
      var ed = editedUrl(fl); if (ed) add('Foto ' + pad2(k + 1) + ' recortada por el cliente', ed);
    });
    if (S.preview && S.preview.url && S.preview.sig === captureSig()) add('Vista previa del cliente', S.preview.url);
    editedSlots().forEach(function (it) {
      var pr = S.prints[it.key];
      if (pr && pr.url && pr.sig === it.sig) add((it.pi === -1 ? 'Portada' : 'Pág ' + pad2(it.pi + 1) + ' · espacio ' + (it.si + 1)) + ' · foto ' + (it.k + 1) + ' lista para imprimir', pr.url);
    });
    add('_diseno_album', JSON.stringify({ c: S.cover, p: S.pages.map(function (p) { return [p.layout, p.slots, capOf(p), p.crops]; }) }));
  }

  /* agrega con el carrito de Shopify, cierra el editor y abre el carrito del tema */
  var adding = false;
  function openCartDrawer() {
    if (window.updateCartBadges) { try { window.updateCartBadges(); } catch (e) {} }
    if (window.refreshCartDrawer) { try { window.refreshCartDrawer(true); return; } catch (e) {} }
    var dr = $('#CartDrawer');
    if (dr && dr.getAttribute('aria-hidden') === 'false') return;
    var btn = $('.cart-badge-container, [data-cart-drawer-toggle], a[href$="/cart"]');
    if (btn) btn.click(); else location.href = '/cart';
  }
  /* ---------- captura para el pedido: portada y todas las páginas en una sola imagen (hoja de contactos) ---------- */
  var capturing = false;
  function captureSig() {
    return JSON.stringify([currentVariant().id, S.files.map(function (f) { return f.uuid; }), S.cover, S.pages.map(function (p) { return [p.layout, p.slots, p.crops, capOf(p)]; })]);
  }
  function withTimeout(p, ms) { return Promise.race([p, new Promise(function (r) { setTimeout(function () { r(null); }, ms); })]); }
  function capture(token) {
    var C = window.WPCapture; if (!C || !S.files.length) return Promise.resolve(null);
    var v = currentVariant(), cc = coverColor(v), n = spreadsCount(), rows = Math.ceil(n / 2);
    var W = 2000, pad = 50, gap = 40, labelH = 46, headH = 170, cellW, pw, ph, Hc;
    function measure() { cellW = (W - pad * 2 - gap) / 2; pw = cellW / 2; ph = pw / AR; Hc = headH + rows * (ph + labelH + 24) + pad + 30; }
    measure();
    while (W * Hc > 14e6 && W > 900) { W -= 100; measure(); }   // límite de memoria de los celulares
    var size = Math.max(160, Math.min(700, Math.round(pw * (S.pages.length > 60 ? 0.6 : 0.9))));
    var need = {}; if (S.cover.photo != null) need[S.cover.photo] = 1;
    S.pages.forEach(function (p) { p.slots.forEach(function (k) { if (k != null) need[k] = 1; }); });
    var urls = S.files.map(function (f, k) { return need[k] ? photoUrl(f, size) : null; });
    if (cc && cc.tex) urls.push(img(cc.tex, 900));
    return C.loadAll(urls, 10).then(function (imgs) {
      if (token && token.cancel) return null;
      var tex = cc && cc.tex ? imgs[imgs.length - 1] : null;
      var cv = C.canvas(W, Hc), ctx = cv.getContext('2d'), SANS = 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif';
      ctx.fillStyle = '#f4f1ec'; ctx.fillRect(0, 0, W, Hc);
      ctx.textBaseline = 'top';
      function drawP(im, x, y, w, hh, c) { if (PE()) PE().draw(ctx, im, x, y, w, hh, c || {}); else C.cover(ctx, im, x, y, w, hh, c); }
      ctx.fillStyle = '#16224a'; ctx.font = '700 34px ' + SANS;
      ctx.fillText('Álbum ' + FAM.name + ' · ' + FAM.size + ' · ' + S.pages.length + ' páginas' + (cc ? ' · tapa ' + cc.name.toLowerCase() : '') + ' · ' + money(v.price), pad, 40);
      ctx.fillStyle = '#4b5470'; ctx.font = '400 22px ' + SANS;
      C.wrap(ctx, [S.cover.title ? 'Título: "' + S.cover.title + '"' : 'Sin título', S.cover.subtitle ? 'Subtítulo: "' + S.cover.subtitle + '"' : '', placedTotal() + ' fotos colocadas de ' + S.files.length + ' subidas'].filter(Boolean).join(' · '), pad, 88, W - pad * 2, 28, 1);
      ctx.fillStyle = '#8a90a3'; ctx.font = '400 18px ' + SANS;
      ctx.fillText('Vista previa que aprobó el cliente · ' + C.stamp() + ' · el número en cada foto es su número en "Carga tus fotos"', pad, 128);
      function page(pi, x, y) {
        ctx.save();
        ctx.shadowColor = 'rgba(13,20,44,.18)'; ctx.shadowBlur = 14; ctx.shadowOffsetY = 4;
        ctx.fillStyle = '#fff'; ctx.fillRect(x, y, pw, ph); ctx.restore();
        ctx.save(); ctx.beginPath(); ctx.rect(x, y, pw, ph); ctx.clip();
        if (pi === -1) {
          var k = S.cover.photo, im = k != null ? imgs[k] : null;
          if (cc) {
            ctx.fillStyle = cc.bg; ctx.fillRect(x, y, pw, ph);
            if (tex) C.cover(ctx, tex, x, y, pw, ph);
            ctx.fillStyle = 'rgba(0,0,0,.16)'; ctx.fillRect(x, y, pw * 0.035, ph);
            var ws = pw * 0.46, tS = Math.max(12, pw * 0.07), sS = Math.max(8, pw * 0.028);
            var blockH = ws + pw * 0.07 + tS * 1.1 + (S.cover.subtitle ? 6 + sS * 1.3 : 0), wy = y + (ph - blockH) / 2, wx = x + (pw - ws) / 2;
            ctx.fillStyle = 'rgba(255,255,255,.14)'; ctx.fillRect(wx, wy, ws, ws);
            if (im) drawP(im, wx, wy, ws, ws, S.cover.crop); else C.hatch(ctx, wx, wy, ws, ws, 'rgba(255,255,255,.18)', 'rgba(255,255,255,.1)');
            ctx.strokeStyle = 'rgba(255,255,255,.25)'; ctx.lineWidth = 3; ctx.strokeRect(wx + 1.5, wy + 1.5, ws - 3, ws - 3);
            if (k != null) C.badge(ctx, String(k + 1), wx + 6, wy + 6, 13);
            ctx.textAlign = 'center'; ctx.fillStyle = cc.foil;
            var ty = wy + ws + pw * 0.07;
            ctx.font = 'italic ' + tS + 'px Georgia, "Times New Roman", serif';
            if (S.cover.title) C.wrap(ctx, S.cover.title, x + pw / 2, ty, pw * 0.86, tS * 1.1, 1);
            if (S.cover.subtitle) { ctx.font = '400 ' + sS + 'px ' + SANS; C.wrap(ctx, S.cover.subtitle.toUpperCase(), x + pw / 2, ty + tS * 1.1 + 6, pw * 0.86, sS * 1.3, 1); }
            ctx.textAlign = 'left';
          } else {
            if (im) drawP(im, x, y, pw, ph, S.cover.crop); else C.hatch(ctx, x, y, pw, ph);
            if (k != null) C.badge(ctx, String(k + 1), x + 8, y + 8, 13);
            var gr = ctx.createLinearGradient(0, y + ph * 0.55, 0, y + ph); gr.addColorStop(0, 'rgba(0,0,0,0)'); gr.addColorStop(1, 'rgba(0,0,0,.55)');
            ctx.fillStyle = gr; ctx.fillRect(x, y + ph * 0.55, pw, ph * 0.45);
            ctx.textAlign = 'center'; ctx.fillStyle = '#fff'; ctx.font = 'italic ' + Math.max(12, pw * 0.07) + 'px Georgia, serif';
            if (S.cover.title) C.wrap(ctx, S.cover.title, x + pw / 2, y + ph * 0.8, pw * 0.86, pw * 0.08, 1);
            if (S.cover.subtitle) { ctx.font = '400 ' + Math.max(8, pw * 0.028) + 'px ' + SANS; C.wrap(ctx, S.cover.subtitle.toUpperCase(), x + pw / 2, y + ph * 0.9, pw * 0.86, pw * 0.04, 1); }
            ctx.textAlign = 'left';
          }
        } else {
          var p = S.pages[pi], L = LMAP[p.layout];
          L.slots.forEach(function (r, si) {
            var sx = x + r[0] / 100 * pw, sy = y + r[1] / 100 * ph, sw = r[2] / 100 * pw, sh = r[3] / 100 * ph, kk = p.slots[si], im2 = kk != null ? imgs[kk] : null;
            ctx.fillStyle = '#eeeae3'; ctx.fillRect(sx, sy, sw, sh);
            if (im2) { drawP(im2, sx, sy, sw, sh, p.crops[si]); C.badge(ctx, String(kk + 1), sx + 4, sy + 4, 11); }
            else if (kk != null) { C.hatch(ctx, sx, sy, sw, sh); C.badge(ctx, String(kk + 1), sx + 4, sy + 4, 11); }
            else { C.hatch(ctx, sx, sy, sw, sh, '#fbeee9', '#f3dcd3'); ctx.fillStyle = '#b4462e'; ctx.font = '700 12px ' + SANS; ctx.fillText('vacío', sx + 6, sy + 6); }
          });
          if (L.text) {
            ctx.fillStyle = '#3d4152'; ctx.textAlign = 'center';
            var fs = Math.max(9, pw * 0.042);
            ctx.font = 'italic ' + fs + 'px Georgia, serif';
            if (capOf(p)) C.wrap(ctx, capOf(p), x + (L.text[0] + L.text[2] / 2) / 100 * pw, y + L.text[1] / 100 * ph + 4, L.text[2] / 100 * pw - 8, fs * 1.2, 3);
            ctx.textAlign = 'left';
          }
          ctx.fillStyle = '#a3a7b5'; ctx.font = '400 11px ' + SANS; ctx.textAlign = 'right';
          ctx.fillText('Pág. ' + (pi + 1), x + pw - 6, y + ph - 16); ctx.textAlign = 'left';
        }
        ctx.restore();
      }
      for (var sp = 0; sp < n; sp++) {
        var col = sp % 2, row = Math.floor(sp / 2);
        var cx = pad + col * (cellW + gap), cy = headH + row * (ph + labelH + 24);
        var pages = spreadPages(sp);
        if (sp === 0) page(-1, cx + pw / 2, cy);
        else pages.forEach(function (pi, j) { page(pi, cx + j * pw, cy); });
        if (sp > 0 && pages.length === 2) { ctx.fillStyle = 'rgba(0,0,0,.08)'; ctx.fillRect(cx + pw - 1, cy, 2, ph); }
        ctx.fillStyle = '#16224a'; ctx.font = '700 20px ' + SANS; ctx.textAlign = 'center';
        ctx.fillText(spreadName(sp), cx + cellW / 2, cy + ph + 12); ctx.textAlign = 'left';
      }
      ctx.fillStyle = '#a3a7b5'; ctx.font = '400 16px ' + SANS;
      ctx.fillText('Wolpic · wolpic.com', pad, Hc - 40);
      if (token && token.cancel) return null;   // ya se agregó sin la imagen: no subir una huérfana
      return C.upload(cv, 'vista-previa-album-' + String(D.current || 'album').replace(/[^a-z0-9-]/gi, '') + '.jpg');
    }).catch(function () { return null; });
  }

  /* espacios con una foto ajustada por el cliente: para cada uno se sube el archivo final para imprimir */
  function editedSlots() {
    var PX = PE(), out = []; if (!PX) return out;
    function push(pi, si, k, c) {
      if (k == null || !S.files[k] || !c || !PX.isSet(c)) return;
      var g = slotGeom(pi, si);
      out.push({ key: pi + ':' + si, pi: pi, si: si, k: k, c: c, aspect: g.aspect, sig: [S.files[k].uuid, JSON.stringify(PX.norm(c)), g.aspect.toFixed(4)].join('|') });
    }
    push(-1, 0, S.cover.photo, S.cover.crop);
    S.pages.forEach(function (p, pi) { p.slots.forEach(function (k, si) { push(pi, si, k, p.crops[si]); }); });
    return out;
  }
  var progressTxt = '';
  function makePrints() {
    var PX = PE(); if (!PX) return Promise.resolve();
    var jobs = editedSlots().filter(function (it) { var pr = S.prints[it.key]; return !(pr && pr.sig === it.sig && pr.url); }).map(function (it) {
      return function () {
        return PX.uploadPrint(S.files[it.k].url, it.c, it.aspect, (it.pi === -1 ? 'portada' : 'pag-' + pad2(it.pi + 1) + '-espacio-' + (it.si + 1)) + '-foto-' + (it.k + 1) + '-lista-para-imprimir.jpg')
          .then(function (u) { if (u) S.prints[it.key] = { sig: it.sig, url: u }; });
      };
    });
    if (!jobs.length) return Promise.resolve();
    progressTxt = 'Preparando tus fotos para imprimir…'; renderReview();
    return PX.pool(jobs, 2, 120000, function (d, t) { progressTxt = 'Preparando tus fotos ' + d + ' de ' + t + '…'; renderReview(); });
  }
  function addToCart() {
    if (adding) return;
    if (DEMO) { toast('Esta es una demostración con fotos de ejemplo. Toca "Usar mis fotos" para armar y comprar tu álbum.'); return; }
    writeProperties();
    var f = productForm(); if (!f) return;
    var sb = f.querySelector('[type="submit"][name="add"]') || f.querySelector('[type="submit"]');
    if (sb && sb.disabled) { toast('Esta opción no está disponible ahora'); return; }
    adding = true; capturing = true; renderReview();
    var sig = captureSig();
    var token = { cancel: false };
    var shot = S.preview && S.preview.sig === sig && S.preview.url ? Promise.resolve(S.preview.url) : withTimeout(capture(token), 45000).then(function (u) { if (!u) token.cancel = true; return u; });
    shot.then(function (url) {
      S.preview = url ? { sig: sig, url: url } : null;
      return makePrints();
    }).then(function () {
      capturing = false; progressTxt = ''; writeProperties(); renderReview();
      addNow(f);
    });
  }
  /* "Continuar sin fotos": agrega el álbum al carrito sin fotos; las envía por WhatsApp después de comprar */
  function continueWithoutPhotos() {
    if (adding || S.files.length) return;
    var C = window.WPCapture, f = productForm(); if (!f) return;
    var sb = f.querySelector('[type="submit"][name="add"]') || f.querySelector('[type="submit"]');
    if (sb && sb.disabled) { toast('Esta opción no está disponible ahora'); return; }
    var ask = C && C.ask ? C.ask(C.NO_PHOTOS) : Promise.resolve(window.confirm('Agregamos tu álbum al carrito sin fotos. Después de tu compra te escribimos por WhatsApp para que nos envíes tus fotos. ¿Continuar?'));
    ask.then(function (ok) {
      if (!ok) { if (editorOpen) openUploader(); else openEditor(); return; }
      writeProperties();
      $$('[data-wpae-prop]', f).forEach(function (n) { if (/_diseno_album/.test(n.name)) n.remove(); });
      var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[Fotos]'; i.value = (C && C.NO_PHOTOS.prop) || 'Sin fotos: las enviará por WhatsApp'; i.setAttribute('data-wpae-prop', '1'); f.appendChild(i);
      adding = true;
      var st = $('.wpae-skip', landing); if (st) { st.disabled = true; st.textContent = 'Agregando…'; }
      addNow(f);
    });
  }
  function addNow(f) {
    var fd = new FormData(f);
    $$('[data-img-id] input[name^="properties["]').forEach(function (inp) { if (!f.contains(inp) && inp.name && !fd.has(inp.name)) fd.append(inp.name, inp.value); });
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        adding = false; S.review = false;
        closeEditor();
        cleared = true; clearTimeout(saveT);
        try { sessionStorage.removeItem(KEY); } catch (e) {}
        toast('¡Tu álbum está en el carrito!');
        setTimeout(openCartDrawer, 450);
      })
      .catch(function (err) {
        adding = false; renderReview(); if (!editorOpen) renderLanding();
        toast((err && err.description) ? String(err.description) : 'No pudimos agregarlo. Revisa tu conexión e inténtalo de nuevo.');
      });
  }

  /* =====================================================================
     LANDING
     ===================================================================== */
  var landing = h('section', 'wpae-landing');
  function coverColor(v) {
    var name = IDX.color > -1 ? v.options[IDX.color] : null, c = name && D.colors[name];
    return c ? { bg: c[0], foil: c[1] || '#e7cf9c', tex: c[2] || '', name: name } : (name ? { bg: '#8a8a8a', foil: '#e7cf9c', tex: '', name: name } : null);
  }
  function swatchStyle(c) { return 'background:' + (c && c[2] ? 'url(&quot;' + esc(img(c[2], 120)) + '&quot;) center / cover, ' : '') + ((c && c[0]) || '#ccc'); }
  /* enlaces internos: conservan la vista previa del tema (preview_theme_id) para no caer en el tema publicado */
  var PREVIEW = (location.search.match(/[?&]preview_theme_id=(\d+)/) || [])[1] || '';
  function viewQs(demo) { return '?view=personalizador' + (demo ? '&demo=1' : '') + (PREVIEW ? '&preview_theme_id=' + PREVIEW : ''); }
  function demoBar() {
    return DEMO ? '<div class="wpae-demo"><strong>Modo demostración:</strong> estas son fotos de ejemplo para probar el editor. <a href="' + esc(location.pathname + viewQs(false)) + '">Usar mis fotos</a></div>' : '';
  }
  function renderLanding() {
    var v = currentVariant(), cap = capacity(v), cc = coverColor(v);
    var images = (P.images || []).slice(0, 5);
    var qs = viewQs(DEMO), stepN = 0, skip = !S.files.length && !DEMO && v.available !== false;
    landing.innerHTML =
      demoBar() +
      '<div class="wpae-hero">' +
        '<div class="wpae-hero__media">' +
          '<img class="wpae-hero__img" src="' + esc(img(images[0] || P.featured_image, 1400)) + '" alt="' + esc(P.title) + '">' +
          '<div class="wpae-hero__thumbs">' + images.map(function (u, i) { return '<button type="button" data-img="' + i + '" style="background-image:url(&quot;' + esc(img(u, 200)) + '&quot;)" aria-label="Ver imagen ' + (i + 1) + '"></button>'; }).join('') + '</div>' +
        '</div>' +
        '<div class="wpae-hero__info">' +
          '<p class="wpae-eyebrow">Fotoálbum ' + esc(FAM.name) + ' · ' + esc(FAM.size) + '</p>' +
          '<h1 class="wpae-h1">' + esc(P.title) + '</h1>' +
          '<p class="wpae-price">' + money(v.price) + '</p>' +
          '<ul class="wpae-points"><li>Diseña tu portada y cada página, paso a paso</li><li>Arrastra tus fotos y ajusta el encuadre</li><li>Lo imprimimos tal como lo diseñas</li></ul>' +
          (FAM.self ? '' : '<div class="wpae-step"><p class="wpae-step__t"><span>' + (++stepN) + '</span>Elige el tamaño</p><div class="wpae-sizes">' +
            D.family.map(function (f) {
              var k = 40 / Math.max(f.w, f.h), on = f.handle === D.current;
              return '<a class="wpae-size' + (on ? ' is-active' : '') + '" href="' + esc(f.url) + qs + '"' + (on ? ' aria-current="true"' : '') + '>' +
                '<i style="width:' + Math.round(f.w * k) + 'px;height:' + Math.round(f.h * k) + 'px"></i><strong>' + esc(f.name) + '</strong><small>' + esc(f.size) + '<br>' + esc(f.photos) + '</small><em>' + (on ? '✓ Elegido' : 'desde ' + esc(f.from)) + '</em></a>';
            }).join('') +
          '</div>' + (S.files.length && !DEMO ? '<p class="wpae-keep">Si cambias de tamaño, tus fotos y tu diseño se mantienen.</p>' : '') + '</div>') +
          (IDX.cap > -1 && values(IDX.cap).length > (FAM.self ? 1 : 0) ? '<div class="wpae-step"><p class="wpae-step__t"><span>' + (++stepN) + '</span>¿Cuántas páginas?</p><div class="wpae-pages">' +
            values(IDX.cap).map(function (val) {
              var o = v.options.slice(); o[IDX.cap] = val; var vv = variantFor(o), lab = capLabel(val), off = !vv || vv.available === false;
              return '<button type="button" class="wpae-pagecard' + (val === v.options[IDX.cap] ? ' is-active' : '') + (off ? ' is-off' : '') + '" data-cap="' + esc(val) + '"' + (off ? ' disabled' : '') + '>' +
                '<strong>' + esc(lab.big) + '</strong>' + (lab.small ? '<small>' + esc(lab.small) + '</small>' : '') + '<em>' + (off ? 'Agotado' : money((vv || v).price)) + '</em></button>';
            }).join('') + '</div></div>' : '') +
          extraOpts().map(function (i) {
            return '<div class="wpae-step"><p class="wpae-step__t"><span>' + (++stepN) + '</span>' + esc(optName(i)) + '</p><div class="wpae-pages">' +
              values(i).map(function (val) {
                var o = v.options.slice(); o[i] = val; var vv = variantFor(o), off = !vv || vv.available === false;
                return '<button type="button" class="wpae-pagecard' + (val === v.options[i] ? ' is-active' : '') + (off ? ' is-off' : '') + '" data-opt="' + i + '" data-val="' + esc(val) + '"' + (off ? ' disabled' : '') + '>' +
                  '<strong>' + esc(val) + '</strong><em>' + (off ? 'Agotado' : money((vv || v).price)) + '</em></button>';
              }).join('') + '</div></div>';
          }).join('') +
          (IDX.color > -1 ? '<div class="wpae-step"><p class="wpae-step__t"><span>' + (++stepN) + '</span>Color de tapa</p><div class="wpae-swatches">' +
            values(IDX.color).map(function (val) {
              var c = D.colors[val], o = v.options.slice(); o[IDX.color] = val; var vv = variantFor(o), off = vv && vv.available === false;
              return '<button type="button" class="wpae-swatch' + (val === v.options[IDX.color] ? ' is-active' : '') + (off ? ' is-off' : '') + '" data-color="' + esc(val) + '"' + (off ? ' disabled' : '') + '><i style="' + swatchStyle(c) + '"></i><small>' + esc(val) + '</small></button>';
            }).join('') + '</div></div>' : '') +
          '<div class="wpae-sum">' +
            '<span class="wpae-sum__cover" style="aspect-ratio:' + FAM.w + ' / ' + FAM.h + ';' + (cc ? swatchStyle([cc.bg, cc.foil, cc.tex]) : 'background:#d9d2c6') + '"></span>' +
            '<span class="wpae-sum__txt"><small>Tu álbum</small><strong>' + esc(FAM.name + ' ' + FAM.size) + '</strong><span>' +
              esc([IDX.cap > -1 ? capLabel(v.options[IDX.cap]).big + (capLabel(v.options[IDX.cap]).small ? ' · ' + capLabel(v.options[IDX.cap]).small : '') : FAM.photos].concat(extraOpts().map(function (i) { return v.options[i]; }), [cc ? 'tapa ' + cc.name.toLowerCase() : 'portada con foto']).filter(Boolean).join(' · ')) +
            '</span></span>' +
            '<b class="wpae-sum__price">' + money(v.price) + '</b>' +
          '</div>' +
          '<button type="button" class="wpae-start"' + (v.available === false ? ' disabled' : '') + '>' + (v.available === false ? 'Agotado' : (S.files.length && !DEMO ? 'Seguir diseñando' : 'Empieza a diseñar') + ' →') + '</button>' +
          (skip ? '<button type="button" class="wpae-skip">Continuar sin fotos</button><p class="wpae-skip-note">Pagas ahora y nos envías tus fotos por WhatsApp después.</p>' : '') +
          '<p class="wpae-note">' + cap.pages + ' páginas · ' + (cap.min ? cap.min + ' a ' : 'hasta ') + cap.max + ' fotos. Primero diseñas la portada y luego cada par de páginas; al final revisas todo y lo agregas al carrito.</p>' +
        '</div>' +
      '</div>' +
      '<div class="wpae-how">' +
        '<div><span>1</span><strong>Sube tus fotos</strong><small>Desde tu celular o computadora.</small></div>' +
        '<div><span>2</span><strong>Diseña paso a paso</strong><small>Portada, luego cada par de páginas con el botón Continuar.</small></div>' +
        '<div><span>3</span><strong>Lo imprimimos y te lo enviamos</strong><small>Tal como lo diseñaste, listo para regalar.</small></div>' +
      '</div>';
    $$('[data-img]', landing).forEach(function (b) { b.addEventListener('click', function () { $('.wpae-hero__img', landing).src = img(images[+b.getAttribute('data-img')], 1400); }); });
    $$('[data-cap]', landing).forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled && !b.classList.contains('is-active')) { b.classList.add('is-active'); selectOption(IDX.cap, b.getAttribute('data-cap')); } }); });
    $$('[data-color]', landing).forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled && !b.classList.contains('is-active')) { b.classList.add('is-active'); selectOption(IDX.color, b.getAttribute('data-color')); } }); });
    $$('.wpae-size', landing).forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (a.classList.contains('is-active')) { e.preventDefault(); return; }
        save(true);
        a.classList.add('is-loading'); $('em', a).textContent = 'Abriendo…';   // cambia de producto: muestra que está cargando
      });
    });
    $$('[data-opt]', landing).forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled && !b.classList.contains('is-active')) { b.classList.add('is-active'); selectOption(+b.getAttribute('data-opt'), b.getAttribute('data-val')); } }); });
    $('.wpae-start', landing).addEventListener('click', function () { openEditor(); });
    var sk = $('.wpae-skip', landing); if (sk) sk.addEventListener('click', continueWithoutPhotos);
    save();
  }

  /* =====================================================================
     EDITOR
     ===================================================================== */
  var editorOpen = false;
  var ed = h('div', 'wpae-editor');
  ed.setAttribute('role', 'dialog'); ed.setAttribute('aria-modal', 'true'); ed.setAttribute('aria-label', 'Editor de tu álbum');
  ed.innerHTML =
    '<header class="wpae-top">' +
      '<button type="button" class="wpae-back" aria-label="Volver">←</button>' +
      '<div class="wpae-top__title"><strong></strong><small></small></div>' +
      '<div class="wpae-top__actions">' +
        '<button type="button" class="wpae-btn wpae-btn--ghost" data-act="auto">Repartir fotos</button>' +
        '<button type="button" class="wpae-btn wpae-btn--primary" data-act="cart"></button>' +
      '</div>' +
    '</header>' +
    '<div class="wpae-demo-slot"></div>' +
    '<div class="wpae-main">' +
      '<aside class="wpae-side">' +
        '<nav class="wpae-tabs"><button type="button" data-tab="portada">Portada</button><button type="button" data-tab="fotos">Fotos</button><button type="button" data-tab="disenos">Diseños</button><button type="button" data-tab="ajustar">Ajustar</button></nav>' +
        '<div class="wpae-panel"></div>' +
      '</aside>' +
      '<section class="wpae-canvas">' +
        '<p class="wpae-guide"></p>' +
        '<div class="wpae-stage"><div class="wpae-spread"></div></div>' +
        '<div class="wpae-stepbar">' +
          '<button type="button" class="wpae-btn wpae-btn--ghost" data-step="-1">← Atrás</button>' +
          '<div class="wpae-stepbar__mid"><strong class="wpae-spreadlabel"></strong><small class="wpae-stepinfo"></small></div>' +
          '<button type="button" class="wpae-btn wpae-btn--primary" data-step="1">Continuar →</button>' +
        '</div>' +
      '</section>' +
    '</div>' +
    '<footer class="wpae-strip"></footer>' +
    '<div class="wpae-review" hidden></div>' +
    '<div class="wpae-ghost" aria-hidden="true"></div>';

  function openEditor() {
    cleared = false;
    if (!S.files.length) { var dom = filesFromDom(); if (dom.length) { setFiles(dom); autofill(); } }
    syncPages();
    if (!S.files.length) { S.spread = 0; S.tab = 'fotos'; }
    else if (S.spread === 0) S.tab = 'portada';
    document.body.appendChild(ed); editorOpen = true;
    try { if (!(history.state && history.state.wpae)) history.pushState({ wpae: 1 }, ''); } catch (e) {}
    document.documentElement.classList.add('wpae-lock');
    $('.wpae-demo-slot', ed).innerHTML = demoBar();
    requestAnimationFrame(function () { ed.classList.add('is-open'); renderEditor(); });
  }
  var ignorePop = false;
  function closeEditor(fromPop) {
    if (fromPop !== true && history.state && history.state.wpae) { ignorePop = true; try { history.back(); } catch (e) { ignorePop = false; } }
    editorOpen = false; S.review = false; ed.classList.remove('is-open');
    document.documentElement.classList.remove('wpae-lock');
    setTimeout(function () { if (ed.parentNode && !editorOpen) ed.parentNode.removeChild(ed); }, 200);
    writeProperties(); renderLanding();
  }
  $('.wpae-back', ed).addEventListener('click', function () { closeEditor(); });
  window.addEventListener('popstate', function () {
    if (ignorePop) { ignorePop = false; return; }
    if (!editorOpen) return;
    if (PE() && PE().isOpen()) { PE().cancel(); try { history.pushState({ wpae: 1 }, ''); } catch (e) {} return; }
    if (document.querySelector('.uploadcare--dialog_status_active, .uploadcare-dialog')) { try { history.pushState({ wpae: 1 }, ''); } catch (e) {} return; }
    if (S.review) { closeReview(); try { history.pushState({ wpae: 1 }, ''); } catch (e) {} return; }
    closeEditor(true);
  });
  $('[data-act="auto"]', ed).addEventListener('click', function () {
    if (!S.files.length) { openUploader(); return; }
    if (placedTotal() && !window.confirm('¿Repartir todas tus fotos de nuevo en orden? Se reemplazan los diseños que elegiste.')) return;
    autofill(); renderEditor(); toast('Repartimos tus fotos en ' + S.pages.length + ' páginas');
  });
  $('[data-act="cart"]', ed).addEventListener('click', openReview);
  $$('[data-tab]', ed).forEach(function (b) { b.addEventListener('click', function () { S.tab = b.getAttribute('data-tab'); renderSide(); }); });
  $$('[data-step]', ed).forEach(function (b) {
    b.addEventListener('click', function () {
      var d = +b.getAttribute('data-step');
      if (d > 0 && S.spread >= spreadsCount() - 1) { openReview(); return; }
      goSpread(S.spread + d);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (!editorOpen || /input|textarea|select/i.test((e.target.tagName || ''))) return;
    if (e.key === 'Escape') {
      if (document.querySelector('.uploadcare--dialog_status_active, .uploadcare-dialog')) return;
      if (S.review) closeReview();
      else if (S.sel.slot != null) { S.sel.slot = null; if (S.tab === 'ajustar') S.tab = S.spread === 0 ? 'portada' : 'fotos'; renderEditor(); }
      else closeEditor();
      return;
    }
    if (S.review) return;
    if (e.key === 'ArrowRight') goSpread(S.spread + 1);
    if (e.key === 'ArrowLeft') goSpread(S.spread - 1);
  });
  function spreadsCount() { return 1 + Math.ceil(S.pages.length / 2); }
  function spreadPages(sp) { return sp === 0 ? [-1] : [2 * sp - 2, 2 * sp - 1].filter(function (i) { return i < S.pages.length; }); }
  function spreadName(sp) { return sp === 0 ? 'Portada' : 'Páginas ' + spreadPages(sp).map(function (i) { return i + 1; }).join(' y '); }
  function goSpread(sp) {
    sp = clamp(sp, 0, spreadsCount() - 1);
    S.spread = sp; S.sel = { page: spreadPages(sp)[0], slot: null }; pick = null;
    if (sp === 0) S.tab = 'portada';
    else if (S.tab === 'portada' || S.tab === 'ajustar') S.tab = 'fotos';
    renderEditor();
  }

  function renderTopbar() {
    var v = currentVariant(), cap = capacity(v), placed = placedTotal();
    $('.wpae-top__title strong', ed).textContent = 'Álbum ' + FAM.name + ' · ' + FAM.size;
    $('.wpae-top__title small', ed).textContent = S.files.length + ' fotos subidas · ' + placed + ' de ' + cap.max + ' colocadas · ' + S.pages.length + ' páginas';
    $('[data-act="cart"]', ed).textContent = S.files.length ? 'Finalizar · ' + money(v.price) : 'Subir fotos';
    var last = S.spread >= spreadsCount() - 1, pages = spreadPages(S.spread);
    $('.wpae-spreadlabel', ed).textContent = spreadName(S.spread);
    var info;
    if (S.spread === 0) info = 'Paso 1 de ' + spreadsCount();
    else {
      var empty = 0, total = 0;
      pages.forEach(function (pi) { S.pages[pi].slots.forEach(function (k) { total++; if (k == null) empty++; }); });
      info = 'Paso ' + (S.spread + 1) + ' de ' + spreadsCount() + ' · ' + (empty ? empty + ' espacio' + (empty > 1 ? 's' : '') + ' sin foto' : '✓ todo con foto');
    }
    $('.wpae-stepinfo', ed).textContent = info;
    $('[data-step="-1"]', ed).disabled = S.spread === 0;
    $('[data-step="1"]', ed).textContent = last ? 'Revisar y finalizar →' : 'Continuar →';
    var guide = !S.files.length
      ? 'Sube tus fotos para empezar: ' + (cap.min ? 'de ' + cap.min + ' a ' : 'hasta ') + cap.max + ' fotos.'
      : S.spread === 0
        ? 'Paso 1 · Tu portada: ' + (coverColor(v) ? 'elige el color de la tapa, ' : '') + 'escribe el título y elige la foto. Luego toca Continuar.'
        : (TOUCH ? 'Toca una foto y luego un espacio.' : 'Arrastra una foto a un espacio, o tócala y luego toca el espacio.') + ' "Diseños" cambia la cuadrícula. Toca una foto puesta (o ✎) para moverla, recortarla, girarla o ponerle filtros.';
    $('.wpae-guide', ed).textContent = guide;
  }

  /* dibuja una página (o la portada) dentro de un contenedor */
  function slotHtml(file, size, c, mini, k) {
    return imgTag(file, size, c) + (!mini ? '<span class="wpae-num">' + (k + 1) + '</span>' : '') +
      (!mini && PE() ? '<button type="button" class="wpx-chip is-icon" data-pe tabindex="-1" aria-label="Editar la foto ' + (k + 1) + '">' + PE().ICON.edit + '</button>' : '');
  }
  /* medida impresa aproximada de un espacio (cm) y su proporción */
  function slotGeom(pi, si) {
    var fw = Number(FAM.w) || 20, fh = Number(FAM.h) || 20;
    if (pi === -1) return coverColor(currentVariant()) ? { aspect: 1, cm: { w: fw * 0.46, h: fw * 0.46 } } : { aspect: AR, cm: { w: fw, h: fh } };
    var r = LMAP[S.pages[pi].layout].slots[si];
    return { aspect: (r[2] * AR) / r[3], cm: { w: r[2] / 100 * fw, h: r[3] / 100 * fh } };
  }
  function openSlotEditor(pi, si) {
    var PX = PE(), k = getSlot(pi, si), file = k != null ? S.files[k] : null; if (!PX || !file) return;
    var g = slotGeom(pi, si), uuid = file.uuid;
    PX.open({
      src: photoUrl(file, 2000), aspect: g.aspect, edit: getCrop(pi, si), cm: g.cm, info: PX.info(file.url),
      title: pi === -1 ? 'Foto de portada' : 'Página ' + (pi + 1) + ' · espacio ' + (si + 1),
      subtitle: 'Foto ' + (k + 1) + ' · así quedará impresa',
      onDone: function (e) {
        var kk = getSlot(pi, si); if (kk == null || !S.files[kk] || S.files[kk].uuid !== uuid) return;
        setCrop(pi, si, e); S.sel = { page: pi, slot: si }; S.tab = 'ajustar'; renderEditor();
      }
    });
  }
  function pageEl(pi, wpx, hpx, mini) {
    var v = currentVariant(), el = h('div', 'wpae-page' + (pi === -1 ? ' wpae-page--cover' : '') + (!mini && S.sel.page === pi && S.sel.slot == null && pi > -1 ? ' is-selected' : ''));
    el.style.width = wpx + 'px'; el.style.height = hpx + 'px';
    el.setAttribute('data-page', pi);
    if (pi === -1) {
      var cc = coverColor(v), file = S.cover.photo != null ? S.files[S.cover.photo] : null, selCover = !mini && S.sel.page === -1 && S.sel.slot === 0;
      var s;
      if (cc) {
        el.style.background = cc.tex ? 'url("' + img(cc.tex, 900) + '") center / cover, ' + cc.bg : cc.bg;
        el.style.setProperty('--foil', cc.foil);
        s = h('div', 'wpae-cover__win wpae-slot' + (file ? '' : ' is-empty') + (selCover ? ' is-selected' : ''));
      } else {
        el.classList.add('wpae-page--photocover');
        s = h('div', 'wpae-slot wpae-cover__full' + (file ? '' : ' is-empty') + (selCover ? ' is-selected' : ''));
      }
      s.setAttribute('data-page', -1); s.setAttribute('data-slot', 0);
      if (!mini) { s.tabIndex = 0; s.setAttribute('role', 'button'); s.setAttribute('aria-label', 'Foto de portada' + (file ? ': foto ' + (S.cover.photo + 1) : ', vacía')); }
      if (file) s.innerHTML = slotHtml(file, mini ? 200 : 1000, S.cover.crop, mini, S.cover.photo);
      else if (!mini) s.innerHTML = '<span class="wpae-plus">+</span>';
      el.appendChild(s);
      var t = h('div', 'wpae-cover__text', '<div class="wpae-cover__t">' + esc(S.cover.title || (mini ? '' : 'Tu título')) + '</div>' + (S.cover.subtitle ? '<div class="wpae-cover__s">' + esc(S.cover.subtitle) + '</div>' : ''));
      if (!S.cover.title) t.classList.add('is-placeholder');
      el.appendChild(t);
      return el;
    }
    var p = S.pages[pi], L = LMAP[p.layout];
    L.slots.forEach(function (r, si) {
      var k = p.slots[si], file = k != null ? S.files[k] : null;
      var s = h('div', 'wpae-slot' + (file ? '' : ' is-empty') + (!mini && S.sel.page === pi && S.sel.slot === si ? ' is-selected' : ''));
      s.style.left = r[0] + '%'; s.style.top = r[1] + '%'; s.style.width = r[2] + '%'; s.style.height = r[3] + '%';
      s.setAttribute('data-page', pi); s.setAttribute('data-slot', si);
      if (!mini) { s.tabIndex = 0; s.setAttribute('role', 'button'); s.setAttribute('aria-label', 'Página ' + (pi + 1) + ', espacio ' + (si + 1) + (file ? ': foto ' + (k + 1) : ', vacío')); }
      if (file) s.innerHTML = slotHtml(file, mini ? 160 : Math.round(Math.max(wpx, hpx) * 1.6), p.crops[si], mini, k);
      else if (!mini) s.innerHTML = '<span class="wpae-plus">+</span>';
      el.appendChild(s);
    });
    if (L.text) {
      var tx = h(mini ? 'div' : 'textarea', 'wpae-caption');
      tx.style.left = L.text[0] + '%'; tx.style.top = L.text[1] + '%'; tx.style.width = L.text[2] + '%'; tx.style.height = L.text[3] + '%';
      if (mini) tx.textContent = p.caption || '';
      else {
        tx.value = p.caption || ''; tx.placeholder = 'Escribe un texto para esta página'; tx.maxLength = 120;
        tx.addEventListener('input', function () { p.caption = tx.value; save(); });
      }
      el.appendChild(tx);
    }
    if (!mini) el.appendChild(h('span', 'wpae-pagenum', 'Pág. ' + (pi + 1)));
    return el;
  }

  function renderSpread() {
    var stage = $('.wpae-stage', ed), spread = $('.wpae-spread', ed);
    spread.innerHTML = '';
    var pages = spreadPages(S.spread), count = S.spread === 0 ? 1 : 2;
    var sw = Math.max(120, stage.clientWidth - 24), sh = Math.max(120, stage.clientHeight - 24);
    var pw = Math.min(sw / count, sh * AR), ph = pw / AR;
    spread.classList.toggle('is-cover', S.spread === 0);
    pages.forEach(function (pi) { spread.appendChild(pageEl(pi, pw, ph, false)); });
    if (count === 2 && pages.length === 1) { var blank = h('div', 'wpae-page wpae-page--blank'); blank.style.width = pw + 'px'; blank.style.height = ph + 'px'; spread.appendChild(blank); }
    if (PE()) PE().applyAll(spread);
  }

  function renderStrip() {
    var strip = $('.wpae-strip', ed); strip.innerHTML = '';
    var th = 54, tw = th * AR;
    for (var sp = 0; sp < spreadsCount(); sp++) {
      var b = h('button', 'wpae-thumb' + (sp === S.spread ? ' is-active' : ''));
      b.type = 'button'; b.setAttribute('data-spread', sp);
      var row = h('span', 'wpae-thumb__row');
      spreadPages(sp).forEach(function (pi) { row.appendChild(pageEl(pi, tw, th, true)); });
      b.appendChild(row);
      var hasEmpty = sp > 0 && spreadPages(sp).some(function (pi) { return S.pages[pi].slots.some(function (k) { return k == null; }); });
      b.appendChild(h('small', hasEmpty ? 'is-warn' : null, (sp === 0 ? 'Portada' : spreadPages(sp).map(function (i) { return i + 1; }).join('-')) + (hasEmpty ? ' •' : '')));
      (function (s) { b.addEventListener('click', function () { goSpread(s); }); })(sp);
      strip.appendChild(b);
    }
    var act = $('.wpae-thumb.is-active', strip); if (act && act.scrollIntoView) act.scrollIntoView({ block: 'nearest', inline: 'center' });
    if (PE()) PE().applyAll(strip);
  }

  function trayHtml(cls) {
    var used = usedCount(), cap = capacity(currentVariant());
    return S.files.map(function (f, k) {
      var over = k >= cap.max;
      return '<button type="button" class="wpae-photo' + (used[k] ? ' is-used' : '') + (S.cover.photo === k && cls === 'cover' ? ' is-cover' : '') + (pick === k ? ' is-picked' : '') + '" data-file="' + k + '" aria-label="Foto ' + (k + 1) + '" style="background-image:url(&quot;' + esc(photoUrl(f, 220)) + '&quot;)">' +
        '<span class="wpae-num">' + (k + 1) + '</span>' + (used[k] ? '<span class="wpae-used">✓</span>' : '') + (over && !used[k] ? '<span class="wpae-over">extra</span>' : '') + '</button>';
    }).join('');
  }
  function renderSide() {
    var selFilled = S.sel.slot != null && getSlot(S.sel.page, S.sel.slot) != null;
    if (S.tab === 'ajustar' && !selFilled) S.tab = S.spread === 0 ? 'portada' : 'fotos';
    $$('[data-tab]', ed).forEach(function (b) {
      var t = b.getAttribute('data-tab');
      b.classList.toggle('is-active', t === S.tab);
      b.hidden = t === 'ajustar' && !selFilled;
    });
    var panel = $('.wpae-panel', ed); panel.innerHTML = '';
    var v = currentVariant(), cap = capacity(v);
    if (S.tab === 'fotos') {
      var placed = placedTotal();
      panel.appendChild(h('p', 'wpae-panel__help', S.files.length
        ? '<b>' + placed + ' de ' + cap.max + '</b> fotos colocadas' + (cap.min ? ' (mínimo ' + cap.min + ')' : '') + '. Arrástralas a las páginas o tócalas.' + (S.files.length > cap.max ? ' Subiste ' + S.files.length + ': las marcadas como "extra" no entran en este álbum.' : '')
        : 'Aún no subiste fotos.'));
      var up = h('button', 'wpae-btn wpae-btn--primary wpae-upload', '+ ' + (S.files.length ? 'Agregar más fotos' : 'Subir fotos'));
      up.type = 'button'; up.addEventListener('click', openUploader); panel.appendChild(up);
      if (!S.files.length && !DEMO) { var sk2 = h('button', 'wpae-skip', 'Continuar sin fotos'); sk2.type = 'button'; sk2.addEventListener('click', continueWithoutPhotos); panel.appendChild(sk2); panel.appendChild(h('p', 'wpae-panel__help wpae-muted', 'Pagas ahora y nos envías tus fotos por WhatsApp después de la compra.')); }
      if (S.files.length) {
        var rep2 = h('button', 'wpae-btn wpae-btn--ghost wpae-wide', 'Repartir todas mis fotos automáticamente');
        rep2.type = 'button'; rep2.addEventListener('click', function () { $('[data-act="auto"]', ed).click(); });
        panel.appendChild(rep2);
      }
      panel.appendChild(h('div', 'wpae-tray', trayHtml('pages')));
    } else if (S.tab === 'disenos') {
      var pi = S.sel.page;
      if (pi === -1 || pi == null) { panel.appendChild(h('p', 'wpae-panel__help', 'Toca una página para cambiar su diseño. La portada se edita en "Portada".')); return; }
      var per = Math.max(1, Math.round(cap.max / S.pages.length));
      panel.appendChild(h('p', 'wpae-panel__help', '<b>Diseño de la página ' + (pi + 1) + '</b><br>Para usar tus ' + cap.max + ' fotos en ' + S.pages.length + ' páginas, lo ideal es unas ' + per + ' fotos por página.'));
      var gridEl = h('div', 'wpae-layouts');
      LAYOUTS.forEach(function (L) {
        var b = h('button', 'wpae-layout' + (S.pages[pi].layout === L.id ? ' is-active' : '') + (L.slots.length === per ? ' is-rec' : ''));
        b.type = 'button'; b.title = L.name;
        var mini = h('span', 'wpae-layout__page'); mini.style.aspectRatio = AR;
        L.slots.forEach(function (r) { var s = h('i'); s.style.left = r[0] + '%'; s.style.top = r[1] + '%'; s.style.width = r[2] + '%'; s.style.height = r[3] + '%'; mini.appendChild(s); });
        if (L.text) { var t = h('b'); t.style.left = L.text[0] + '%'; t.style.top = L.text[1] + '%'; t.style.width = L.text[2] + '%'; t.style.height = L.text[3] + '%'; mini.appendChild(t); }
        b.appendChild(mini); b.appendChild(h('small', null, esc(L.name)));
        b.addEventListener('click', function () { setLayout(pi, L.id); renderEditor(); });
        gridEl.appendChild(b);
      });
      panel.appendChild(gridEl);
      var both = h('button', 'wpae-btn wpae-btn--ghost wpae-wide', 'Usar este diseño en todas las páginas');
      both.type = 'button';
      both.addEventListener('click', function () { layoutAll(S.pages[pi].layout); renderEditor(); });
      panel.appendChild(both);
    } else if (S.tab === 'ajustar' && PE()) {
      var PX = PE(), kq = getSlot(S.sel.page, S.sel.slot), cq = getCrop(S.sel.page, S.sel.slot), sp = S.sel.page, ss = S.sel.slot;
      var slotEl = function () { return $('.wpae-spread .wpae-slot[data-page="' + sp + '"][data-slot="' + ss + '"]', ed); };
      panel.insertAdjacentHTML('beforeend',
        '<p class="wpae-panel__help"><b>Foto ' + (kq + 1) + (sp === -1 ? ' · portada' : ' · página ' + (sp + 1)) + '</b><br>Arrastra la foto dentro del espacio para moverla, o abre el editor para recortarla, girarla, enderezarla o ponerle filtros.</p>' +
        '<button type="button" class="wpae-adj-main" data-crop="edit">' + PX.ICON.edit + 'Editar foto</button>' +
        '<label class="wpae-panel__label" for="wpae-zoom">Zoom</label>' +
        '<input class="wpae-range" id="wpae-zoom" type="range" min="1" max="5" step="0.05" value="' + cq.z + '">' +
        '<div class="wpae-adj-row"><button type="button" data-crop="rot">' + PX.ICON.right + 'Girar</button><button type="button" data-crop="mirror"' + (cq.fh ? ' class="is-on"' : '') + '>' + PX.ICON.mirror + 'Espejo</button><button type="button" data-crop="center">' + PX.ICON.center + 'Centrar</button><button type="button" data-crop="remove"><span aria-hidden="true" style="font-size:17px;line-height:18px">✕</span>Quitar</button></div>' +
        (cropIsSet(cq) ? '<p class="wpae-panel__help wpae-muted">Ajustes: ' + esc(PX.describe(cq)) + ' · <button type="button" class="wpae-link" data-crop="undo">Quitar ajustes</button></p>' : '') +
        '<button type="button" class="wpae-btn wpae-btn--primary wpae-wide" data-crop="done">Listo</button>' +
        '<p class="wpae-panel__help wpae-muted">Para cambiar la foto de este espacio, toca otra en "Fotos".</p>');
      $('#wpae-zoom', panel).addEventListener('input', function (e) {
        var cc = getCrop(sp, ss); cc.z = +e.target.value; setCrop(sp, ss, cc); applyCrop(slotEl(), getCrop(sp, ss)); save();
      });
      $('#wpae-zoom', panel).addEventListener('change', function () { writeProperties(); renderStrip(); });
      var act = function (name, fn) { var b = $('[data-crop="' + name + '"]', panel); if (b) b.addEventListener('click', fn); };
      act('edit', function () { openSlotEditor(sp, ss); });
      act('rot', function () { var cc = getCrop(sp, ss); cc.r += 90; setCrop(sp, ss, cc); renderEditor(); });
      act('mirror', function () { var cc = getCrop(sp, ss); cc.fh = cc.fh ? 0 : 1; setCrop(sp, ss, cc); renderEditor(); });
      act('center', function () { var cc = getCrop(sp, ss); cc.fx = 0.5; cc.fy = 0.5; setCrop(sp, ss, cc); renderEditor(); });
      act('undo', function () { setCrop(sp, ss, null); renderEditor(); });
      act('remove', function () { placeFile(null, sp, ss); if (sp === -1) S.cover.photo = null; S.sel.slot = null; renderEditor(); });
      act('done', function () { S.sel.slot = null; S.tab = S.spread === 0 ? 'portada' : 'fotos'; renderEditor(); });
    } else if (S.tab === 'ajustar') {
      var k = getSlot(S.sel.page, S.sel.slot), c = getCrop(S.sel.page, S.sel.slot);
      panel.insertAdjacentHTML('beforeend',
        '<p class="wpae-panel__help"><b>Ajustar foto ' + (k + 1) + '</b><br>Arrastra la foto dentro del espacio para elegir qué parte se ve, y usa el zoom para acercarla.</p>' +
        '<label class="wpae-panel__label" for="wpae-zoom">Zoom</label>' +
        '<input class="wpae-range" id="wpae-zoom" type="range" min="1" max="3" step="0.05" value="' + c.z + '">' +
        '<div class="wpae-row"><button type="button" class="wpae-btn wpae-btn--ghost" data-crop="reset">Centrar</button><button type="button" class="wpae-btn wpae-btn--ghost" data-crop="remove">Quitar foto</button></div>' +
        '<button type="button" class="wpae-btn wpae-btn--primary wpae-wide" data-crop="done">Listo</button>' +
        '<p class="wpae-panel__help wpae-muted">Para cambiar la foto de este espacio, toca otra en "Fotos".</p>');
      $('#wpae-zoom', panel).addEventListener('input', function (e) {
        var cc = getCrop(S.sel.page, S.sel.slot); cc = { x: cc.x, y: cc.y, z: +e.target.value };
        setCrop(S.sel.page, S.sel.slot, cc);
        applyCrop($('.wpae-spread .wpae-slot[data-page="' + S.sel.page + '"][data-slot="' + S.sel.slot + '"]', ed), cc); save();
      });
      $('[data-crop="reset"]', panel).addEventListener('click', function () { setCrop(S.sel.page, S.sel.slot, null); renderEditor(); });
      $('[data-crop="remove"]', panel).addEventListener('click', function () { placeFile(null, S.sel.page, S.sel.slot); if (S.sel.page === -1) S.cover.photo = null; S.sel.slot = null; renderEditor(); });
      $('[data-crop="done"]', panel).addEventListener('click', function () { S.sel.slot = null; S.tab = S.spread === 0 ? 'portada' : 'fotos'; renderEditor(); });
    } else {
      if (IDX.color > -1) {
        panel.appendChild(h('p', 'wpae-panel__label', 'Color de tapa'));
        var sws = h('div', 'wpae-swatches');
        values(IDX.color).forEach(function (val) {
          var oo = v.options.slice(); oo[IDX.color] = val; var vv = variantFor(oo), anyOk = P.variants.some(function (x) { return x.options[IDX.color] === val && x.available !== false; });
          var b = h('button', 'wpae-swatch' + (val === v.options[IDX.color] ? ' is-active' : '') + (!anyOk ? ' is-off' : ''), '<i style="' + swatchStyle(D.colors[val]) + '"></i><small>' + esc(val) + (!anyOk ? ' (agotado)' : (vv && vv.available === false ? ' (otra capacidad)' : '')) + '</small>');
          b.type = 'button'; b.disabled = !anyOk;
          b.addEventListener('click', function () { if (val !== currentVariant().options[IDX.color]) selectOption(IDX.color, val); });
          sws.appendChild(b);
        });
        panel.appendChild(sws);
      }
      panel.insertAdjacentHTML('beforeend',
        '<label class="wpae-panel__label" for="wpae-ct">Título</label><input class="wpae-input" id="wpae-ct" maxlength="30" placeholder="Ej. Nuestro primer año">' +
        '<label class="wpae-panel__label" for="wpae-cs">Subtítulo o fecha</label><input class="wpae-input" id="wpae-cs" maxlength="40" placeholder="Ej. Cusco · 2026">' +
        '<p class="wpae-panel__label">Foto de portada</p><p class="wpae-panel__help">Toca una foto o arrástrala a la portada. Luego tócala en la portada para ajustarla.</p>');
      $('#wpae-ct', panel).value = S.cover.title; $('#wpae-cs', panel).value = S.cover.subtitle;
      $('#wpae-ct', panel).addEventListener('input', function (e) { S.cover.title = e.target.value.trim(); renderSpread(); renderStrip(); save(); });
      $('#wpae-cs', panel).addEventListener('input', function (e) { S.cover.subtitle = e.target.value.trim(); renderSpread(); renderStrip(); save(); });
      if (S.files.length) panel.appendChild(h('div', 'wpae-tray wpae-tray--small', trayHtml('cover')));
      else { var up2 = h('button', 'wpae-btn wpae-btn--primary wpae-upload', '+ Subir fotos'); up2.type = 'button'; up2.addEventListener('click', openUploader); panel.appendChild(up2); }
    }
  }

  /* ---------- revisión final ---------- */
  function checks() {
    var v = currentVariant(), cap = capacity(v), placed = placedTotal(), out = [];
    if (!S.files.length) { out.push({ t: 'err', m: 'Aún no subiste fotos.' }); return out; }
    if (placed > cap.max) out.push({ t: 'err', m: 'Tu álbum incluye hasta ' + cap.max + ' fotos y colocaste ' + placed + '. Quita ' + (placed - cap.max) + ' o elige más páginas.' });
    else out.push({ t: cap.min && placed < cap.min ? 'warn' : 'ok', m: placed + ' de ' + cap.max + ' fotos colocadas' + (cap.min && placed < cap.min ? ' (este álbum es para ' + cap.min + ' a ' + cap.max + ' fotos)' : '') + '.' });
    var cc = coverColor(v);
    out.push(S.cover.photo != null ? { t: 'ok', m: 'Portada con foto' + (cc ? ', tapa ' + cc.name.toLowerCase() : '') + (S.cover.title ? ' y título "' + S.cover.title + '"' : ' (sin título)') + '.' } : { t: 'warn', m: 'La portada no tiene foto.', go: 0 });
    var empty = emptySlots();
    if (empty.length) {
      var pages = empty.filter(function (x, i) { return empty.indexOf(x) === i; });
      out.push({ t: 'warn', m: empty.length + (empty.length > 1 ? ' espacios quedan' : ' espacio queda') + ' sin foto (pág. ' + pages.slice(0, 8).map(function (i) { return i + 1; }).join(', ') + (pages.length > 8 ? '…' : '') + '). Se imprimirían en blanco.', go: 1 + Math.floor(pages[0] / 2) });
    } else out.push({ t: 'ok', m: 'Todas las páginas tienen sus fotos.' });
    var used = usedCount(), unused = S.files.filter(function (f, k) { return !used[k] && S.cover.photo !== k; }).length;
    if (unused) out.push({ t: 'info', m: unused + (unused > 1 ? ' fotos subidas no están' : ' foto subida no está') + ' en el álbum.' });
    return out;
  }
  function openReview() {
    if (!S.files.length) { openUploader(); return; }
    S.review = true; renderReview();
  }
  function closeReview() { S.review = false; renderReview(); }
  function renderReview() {
    var box = $('.wpae-review', ed);
    if (!S.review) { box.hidden = true; box.innerHTML = ''; return; }
    var v = currentVariant(), list = checks(), blocked = list.some(function (c) { return c.t === 'err'; }), cc = coverColor(v);
    var hasEmpty = list.some(function (c) { return c.go != null && c.go > 0; });
    box.hidden = false;
    box.innerHTML =
      '<div class="wpae-review__card" role="dialog" aria-label="Revisa tu álbum">' +
        '<h3>Revisa tu álbum</h3>' +
        '<p class="wpae-review__sum">Álbum ' + esc(FAM.name + ' ' + FAM.size) + ' · ' + S.pages.length + ' páginas' + (cc ? ' · tapa ' + esc(cc.name.toLowerCase()) : '') + ' · <b>' + money(v.price) + '</b></p>' +
        '<ul class="wpae-checks">' + list.map(function (c) {
          return '<li class="is-' + c.t + '"><span>' + (c.t === 'ok' ? '✓' : c.t === 'err' ? '!' : c.t === 'warn' ? '!' : 'i') + '</span><div>' + esc(c.m) + (c.go != null ? ' <button type="button" class="wpae-link" data-go="' + c.go + '">Ir a ' + esc(spreadName(c.go).toLowerCase()) + '</button>' : '') + '</div></li>';
        }).join('') + '</ul>' +
        '<p class="wpae-review__note">Imprimimos tu álbum tal como lo ves aquí: revisa cada página antes de agregarlo al carrito.</p>' +
        '<div class="wpae-review__actions">' +
          '<button type="button" class="wpae-btn wpae-btn--ghost" data-rv="back">Seguir editando</button>' +
          (hasEmpty ? '<button type="button" class="wpae-btn wpae-btn--ghost" data-rv="fill">Completar espacios vacíos</button>' : '') +
          '<button type="button" class="wpae-btn wpae-btn--primary" data-rv="cart"' + (blocked || adding ? ' disabled' : '') + '>' + (adding ? (capturing ? (progressTxt || 'Guardando tu vista previa…') : 'Agregando…') : 'Agregar al carrito · ' + money(v.price)) + '</button>' +
        '</div>' +
      '</div>';
    $$('[data-go]', box).forEach(function (b) { b.addEventListener('click', function () { S.review = false; renderReview(); goSpread(+b.getAttribute('data-go')); }); });
    $('[data-rv="back"]', box).addEventListener('click', closeReview);
    var fill = $('[data-rv="fill"]', box); if (fill) fill.addEventListener('click', fillEmpty);
    $('[data-rv="cart"]', box).addEventListener('click', addToCart);
  }
  /* completa los espacios vacíos con las fotos que no se usaron (sin pasar el límite); si no alcanzan, ajusta el diseño de esas páginas */
  function fillEmpty() {
    var cap = capacity(currentVariant()), used = usedCount(), free = [], before = emptySlots().length;
    S.files.forEach(function (f, k) { if (!used[k] && S.cover.photo !== k) free.push(k); });
    S.pages.forEach(function (p) { p.slots.forEach(function (k, si) { if (k == null && free.length && placedTotal() < cap.max) { p.slots[si] = free.shift(); p.crops[si] = null; } }); });
    S.pages.forEach(function (p, pi) {
      var n = p.slots.filter(function (k) { return k != null; }).length;
      if (n && n < p.slots.length) setLayout(pi, LMAP[p.layout].text && n === 1 ? 'text' : layoutForCount(n), true);
    });
    if (emptySlots().length === before) toast('No quedan fotos libres para esos espacios: sube más fotos o cambia el diseño de esas páginas');
    renderEditor(); renderReview();
  }

  var focusKey = null;
  function renderEditor() {
    if (!editorOpen) return;
    syncPages(); renderTopbar(); renderSide();
    var st = $('.wpae-strip', ed); if (st && getComputedStyle(st).display !== 'none') renderStrip();
    renderSpread(); renderReview();
    writeProperties(); save();
    if (focusKey) { var el = $(focusKey, ed); focusKey = null; if (el) try { el.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- colocar fotos: tocar o arrastrar; encuadrar arrastrando la foto elegida ---------- */
  var pick = null; // foto tocada en la bandeja, esperando un espacio
  function firstEmptyInSpread() {
    var target = null;
    spreadPages(S.spread).forEach(function (pi) {
      if (target) return;
      if (pi === -1) target = { page: -1, slot: 0 };
      else S.pages[pi].slots.forEach(function (k, si) { if (!target && k == null) target = { page: pi, slot: si }; });
    });
    return target;
  }
  ed.addEventListener('pointerdown', function (e) {
    if (S.review) return;
    if (e.target.closest('[data-pe]')) return;
    var ph = e.target.closest('.wpae-tray .wpae-photo'), slot = e.target.closest('.wpae-spread .wpae-slot');
    if (!ph && !slot) {
      var pg = e.target.closest('.wpae-spread .wpae-page');
      if (pg && pg.hasAttribute('data-page') && !e.target.closest('.wpae-caption')) {
        var pnum = +pg.getAttribute('data-page');
        if (pnum > -1) { S.sel = { page: pnum, slot: null }; S.tab = 'disenos'; renderEditor(); }
      }
      return;
    }
    if (ph) { S.drag = { type: 'file', k: +ph.getAttribute('data-file'), cover: !!ph.closest('.wpae-tray--small'), x: e.clientX, y: e.clientY, moved: false }; return; }
    var pi = +slot.getAttribute('data-page'), si = +slot.getAttribute('data-slot');
    if (S.sel.page === pi && S.sel.slot === si && getSlot(pi, si) != null) {
      var r = slot.getBoundingClientRect(), c = getCrop(pi, si);
      S.drag = { type: 'pan', page: pi, slot: si, x: e.clientX, y: e.clientY, w: r.width, h: r.height, c: PE() ? PE().norm(c) : { x: c.x, y: c.y, z: c.z }, el: slot, moved: false };
      try { slot.setPointerCapture(e.pointerId); } catch (err) {}
      return;
    }
    S.drag = { type: 'slot', page: pi, slot: si, x: e.clientX, y: e.clientY, moved: false };
  });
  ed.addEventListener('pointermove', function (e) {
    var d = S.drag; if (!d) return;
    var dx = e.clientX - d.x, dy = e.clientY - d.y;
    if (!d.moved && Math.sqrt(dx * dx + dy * dy) < 8) return;
    if (d.type === 'pan') {
      d.moved = true; e.preventDefault();
      var nc, pim = PE() && d.el.querySelector('.wpae-img');
      if (PE()) { if (!pim || !pim.naturalWidth) return; nc = PE().panBy(d.c, dx, dy, d.el.clientWidth, d.el.clientHeight, pim.naturalWidth, pim.naturalHeight); }
      else { var k = 1 / d.c.z; nc = { x: clamp(d.c.x - dx / d.w * 100 * k, 0, 100), y: clamp(d.c.y - dy / d.h * 100 * k, 0, 100), z: d.c.z }; }
      setCrop(d.page, d.slot, nc); applyCrop(d.el, nc);
      return;
    }
    var fk = d.type === 'file' ? d.k : getSlot(d.page, d.slot);
    if (fk == null) return;
    var ghost = $('.wpae-ghost', ed);
    if (!d.moved) { d.moved = true; ghost.style.backgroundImage = 'url("' + photoUrl(S.files[fk], 200) + '")'; ghost.classList.add('is-on'); ed.classList.add('is-dragging'); }
    e.preventDefault();
    ghost.style.transform = 'translate(' + (e.clientX - 40) + 'px,' + (e.clientY - 40) + 'px)';
    $$('.wpae-slot.is-over', ed).forEach(function (n) { n.classList.remove('is-over'); });
    var under = document.elementFromPoint(e.clientX, e.clientY), s = under && under.closest('.wpae-spread .wpae-slot');
    if (s) s.classList.add('is-over');
  });
  function endDrag(e) {
    var d = S.drag; S.drag = null; if (!d) return;
    $('.wpae-ghost', ed).classList.remove('is-on'); ed.classList.remove('is-dragging');
    $$('.wpae-slot.is-over', ed).forEach(function (n) { n.classList.remove('is-over'); });
    if (d.type === 'pan') { if (d.moved) { writeProperties(); save(); renderStrip(); } return; }
    if (!d.moved) {
      if (d.type === 'file') {
        if (d.cover) { placeFile(d.k, -1, 0); if (S.spread !== 0) S.spread = 0; }
        else if (S.sel.slot != null) { placeFile(d.k, S.sel.page, S.sel.slot); S.sel.slot = null; if (S.tab === 'ajustar') S.tab = 'fotos'; }
        else {
          var target = firstEmptyInSpread();
          if (target && !(target.page === -1 && S.cover.photo != null && S.spread !== 0)) placeFile(d.k, target.page, target.slot);
          else { pick = pick === d.k ? null : d.k; if (pick != null) toast('Ahora toca el espacio donde quieres la foto ' + (d.k + 1)); }
        }
      } else {
        var k = getSlot(d.page, d.slot);
        if (pick != null) { placeFile(pick, d.page, d.slot); pick = null; }
        else if (S.sel.page === d.page && S.sel.slot === d.slot) {
          if (k != null && PE()) { openSlotEditor(d.page, d.slot); return; }   // segundo toque sobre la foto elegida: abre el editor
          S.sel.slot = null; if (S.tab === 'ajustar') S.tab = S.spread === 0 ? 'portada' : 'fotos';
        }
        else { S.sel = { page: d.page, slot: d.slot }; S.tab = k == null ? 'fotos' : 'ajustar'; }
      }
      renderEditor(); return;
    }
    var under = document.elementFromPoint(e.clientX, e.clientY), s = under && under.closest('.wpae-spread .wpae-slot');
    if (s) {
      var to = { page: +s.getAttribute('data-page'), slot: +s.getAttribute('data-slot') };
      var capM = capacity(currentVariant()).max;
      if (d.type === 'file') placeFile(d.k, to.page, to.slot);
      else if (d.page === -1 && to.page > -1 && getSlot(to.page, to.slot) == null && placedTotal() >= capM) toast('Tu álbum incluye hasta ' + capM + ' fotos. Quita una foto o elige más páginas.');
      else { swapSlots({ page: d.page, slot: d.slot }, to); S.touched = true; }
    } else if (d.type === 'slot' && under && under.closest('.wpae-side')) {
      placeFile(null, d.page, d.slot);     // arrastrar fuera, a la bandeja: quita la foto
      if (d.page === -1) S.cover.photo = null;
    }
    renderEditor();
  }
  ed.addEventListener('pointerup', endDrag);
  ed.addEventListener('keydown', function (e) {
    if ((e.key !== 'Enter' && e.key !== ' ') || S.review) return;
    var ph = e.target.closest && e.target.closest('.wpae-tray .wpae-photo'), sl = e.target.closest && e.target.closest('.wpae-spread .wpae-slot');
    if (!ph && !sl) return;
    e.preventDefault();
    focusKey = ph ? '.wpae-tray' + (ph.closest('.wpae-tray--small') ? '--small' : '') + ' .wpae-photo[data-file="' + ph.getAttribute('data-file') + '"]'
      : '.wpae-spread .wpae-slot[data-page="' + sl.getAttribute('data-page') + '"][data-slot="' + sl.getAttribute('data-slot') + '"]';
    S.drag = ph ? { type: 'file', k: +ph.getAttribute('data-file'), cover: !!ph.closest('.wpae-tray--small'), moved: false }
      : { type: 'slot', page: +sl.getAttribute('data-page'), slot: +sl.getAttribute('data-slot'), moved: false };
    endDrag({});
  });
  document.addEventListener('pointerup', function (e) { if (S.drag && editorOpen && !ed.contains(e.target)) endDrag(e); });
  ed.addEventListener('pointercancel', function () { S.drag = null; $('.wpae-ghost', ed).classList.remove('is-on'); ed.classList.remove('is-dragging'); });
  ed.addEventListener('click', function (e) {
    if (e.target === $('.wpae-review', ed)) { closeReview(); return; }
    var pe = e.target.closest('[data-pe]');
    if (pe) {
      var sl = pe.closest('.wpae-slot'); if (!sl) return;
      e.preventDefault(); e.stopPropagation();
      var pi = +sl.getAttribute('data-page'), si = +sl.getAttribute('data-slot');
      S.sel = { page: pi, slot: si }; S.tab = 'ajustar'; renderEditor(); openSlotEditor(pi, si);
    }
  });
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (editorOpen) renderSpread(); }, 120); });

  /* ---------- montar ---------- */
  function mount() {
    var grid = $('.product-main-grid'), host = grid ? grid.parentNode : root.parentNode;
    host.insertBefore(landing, grid || null);
    if (grid) grid.classList.add('wpae-hide');
    lastVariantId = String(currentVariant().id); lastMax = capacity(currentVariant()).max;
    syncPages();
    if (DEMO) {
      // demo para reuniones: ?demo=1 carga fotos de ejemplo (no se guardan ni se mezclan con las del cliente)
      var ids = [1011, 1025, 1027, 1062, 1015, 1043, 1050, 64, 65, 1035, 1039, 1044, 1047, 1059, 1069, 1074, 1080, 1084, 110, 129, 133, 152, 164, 177, 180, 184, 188, 192, 200, 203];
      var shop = (D.demo || []).filter(Boolean).map(function (u) { return u.indexOf('//') === 0 ? 'https:' + u : u; });
      var urls = shop.length >= 12 ? shop.slice(0, 30) : ids.map(function (id) { return 'https://picsum.photos/id/' + id + '/900/900'; });
      setFiles(urls.map(function (u, i) { return { uuid: 'demo' + i, name: 'foto-' + (i + 1) + '.jpg', url: u, link: '' }; }));
      autofill();
    } else {
      var dom = filesFromDom(), saved = load(), files = dom;
      if (saved && saved.files.length) {
        var byDom = {}; dom.forEach(function (f) { byDom[f.uuid] = f; });
        files = dom.concat(saved.files.filter(function (f) { return !byDom[f.uuid]; }));
        files.forEach(function (f) { if (!byDom[f.uuid]) S.carried[f.uuid] = 1; });
      }
      if (files.length) {
        setFiles(files);
        var ok = !!(saved && restoreDesign(saved));
        if (!ok) autofill();
        if (Object.keys(S.carried).length) toast(ok ? 'Trajimos tus ' + files.length + ' fotos y tu diseño' : 'Trajimos tus ' + files.length + ' fotos');
      }
    }
    renderLanding();
    var f = productForm(), idInput = f && f.querySelector('[name="id"]');
    if (idInput && window.MutationObserver) new MutationObserver(function () { setTimeout(afterVariant, 30); }).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') setTimeout(afterVariant, 30); }, true);
    writeProperties();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  window.WolpicAlbumEditor = { state: S, open: openEditor, review: openReview, capture: capture, edit: openSlotEditor, prints: makePrints, setFiles: function (l) { setFiles(l); autofill(); renderLanding(); if (editorOpen) renderEditor(); } };
})();
